/**
 * Coaching formatting utilities
 */

export function formatTime(time: string): string {
  const [hours, minutes] = time.split(":")
  const h = Number.parseInt(hours, 10)
  const ampm = h >= 12 ? "PM" : "AM"
  const h12 = h % 12 || 12
  return `${h12}:${minutes} ${ampm}`
}

export function formatPrice(fee: number | null, feeCurrency?: string | null): string {
  if (fee == null || fee <= 0) return "Free"
  const symbol = feeCurrency === "USD" ? "$" : (feeCurrency ?? "")
  return `${symbol}${fee}`
}

export function formatDate(dateStr: string): string {
  const date = new Date(`${dateStr}T12:00:00`)
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  })
}

export function toDateString(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
}
